import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRDialog } from 'src/app/models/qr-dialog.model';
import { ConfigDeleteUserComponent } from '../../dialogs/config-delete-user/config-delete-user.component';
import { ElectronicBillingSaveComprobantesComponent } from '../../dialogs/electronic-billing-save-comprobantes/electronic-billing-save-comprobantes.component';
import { ElectronicBillingDownloadLibroIvaComponent } from '../../dialogs/electronic-billing-download-libro-iva/electronic-billing-download-libro-iva.component';
import { ConfigEditCashflowNameComponent } from '../../dialogs/config-edit-cashflow-name/config-edit-cashflow-name.component';
import { ConfigAddEditCompensationComponent } from '../../dialogs/config-add-edit-compensation/config-add-edit-compensation.component';
import { ConfigAddEditNotificationsComponent } from '../../dialogs/config-add-edit-notifications/config-add-edit-notifications.component';
import { RrhhRemoveAgentComponent } from '../../dialogs/rrhh-remove-agent/rrhh-remove-agent.component';
import { DialogChangePasswordComponent } from '../../dialogs/dialog-change-password/dialog-change-password.component';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { RenditionFinishMovementsComponent } from '../../dialogs/renditions/rendition-finish-movements/rendition-finish-movements.component';
import { RenditionDraftCreatedComponent } from '../../dialogs/renditions/rendition-draft-created/rendition-draft-created.component';
import { RenditionFormLoadDraftComponent } from '../../dialogs/renditions/rendition-form-load-draft/rendition-form-load-draft.component';
import { RrhhImportTeamComponent } from '../../dialogs/rrhh-import-team/rrhh-import-team.component';

@Component({
  selector: 'qr-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  @Input() config!: QRDialog;
  @Output() dialogChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() buttonActionDisabled?: boolean = false;
  valueChange: any;
  changeSubscription: Subscription | undefined;
  dialogChangeSubscription: Subscription | undefined;

  buttonClose: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
  };

  buttonAction: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Botón',
  };

  buttonAction2: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Botón',
  };

  buttonCancel: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Botón',
  };

  // Componente dinamico
  @ViewChild('dinamicContainer', { read: ViewContainerRef })
  target!: ViewContainerRef;
  private componentRef!: ComponentRef<any>;

  // Eventos de teclado
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key == 'Escape' && this.config.isVisible) {
      // Tecla ESC: Cierra Diálogo
      this.close();
    }
  }

  tempScrollTop: number | undefined;

  constructor(private readonly cdRef: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config']) {
      this.buttonAction.viewValue = this.config.textButtonAction;
      this.buttonCancel.viewValue = this.config.textButtonCancel;
      this.buttonAction2.viewValue = this.config.textButtonAction2;

      if (this.config.isVisible) {
        // Esto logra que no se mueva el scroll del body al estar scrolleando el diálogo
        this.tempScrollTop = window.pageYOffset;
        document.body.classList.add('disable-scroll');
        document.body.style.top = '-' + this.tempScrollTop + 'px';
        this.addComponentDynamically();
      } else {
        this.close()
      }
    }
  }

  ngOnDestroy(): void {
    this.changeSubscription?.unsubscribe();
    this.dialogChangeSubscription?.unsubscribe();
  }

  action(): void {
    if (!this.buttonActionDisabled) {
      this.dialogChange.emit(this.valueChange);
      this.closeButton('ok');
    }
  }
  action2(): void {
    this.dialogChange.emit('action2');
  }

  close(): void {
    if (!this.config.isNotCloseable) {
      this.config.isVisible = false;
      // Se habilita nuevamente el scroll del body y se lleva al scroll original
      document.body.classList.remove('ng-scope', 'disable-scroll');
      document.body.style.top = '0px';
      window.scrollTo({ top: this.tempScrollTop });
    }
  }

  // Lamentablemente debo pasar una variable para lograr un comportamiento especifico con el dialogo. La pongo opcional por si es necesario saber si se cierra por parte de un hecho success o si se cerro por boton cerrar o cancelar.
  closeButton(success?: string) {
    if (!this.config.isNotCloseable) {
      if (
        this.config.componentToLoad ==
          ElectronicBillingSaveComprobantesComponent &&
        success != 'ok'
      ) {
        this.dialogChange.emit('close');
      }
      if (this.config.componentToLoad == RrhhRemoveAgentComponent) {
        this.dialogChange.emit('close');
      }
      //Dialogo de rendiciones → finalizar movimientos, 2 acciones
      if (this.config.componentToLoad == RenditionFinishMovementsComponent) {
        this.dialogChange.emit(success);
      }
      //Dialogo de rendiciones → finalizar borrador, 2 acciones
      if (this.config.componentToLoad == RenditionDraftCreatedComponent) {
        this.dialogChange.emit(success);
      }
      //Dialogo de rendiciones → finalizar borrador, 2 acciones
      if (this.config.componentToLoad == RenditionFormLoadDraftComponent) {
        this.dialogChange.emit(null);
      }
      this.config.isVisible = false;
      // Se habilita nuevamente el scroll del body y se lleva al scroll original
      document.body.classList.remove('ng-scope', 'disable-scroll');
      document.body.style.top = '0px';
      window.scrollTo({ top: this.tempScrollTop });
    }else {
      //Dialogo en creacion de team --> finalizar movimientos
      if (this.config.componentToLoad == RrhhImportTeamComponent) {
        this.close();
      }
      this.config.isVisible = false;
    }
  }

  /*
	addComponentDynamically: Agregar un componente de forma dinámica
	*/
  addComponentDynamically() {
    this.cdRef.detectChanges(); // run change detection immediately
    if (this.target) {
      this.target.clear(); // Limpiar contenedor de componentes dinámicos
      this.componentRef = this.target.createComponent(
        this.config.componentToLoad
      );
    }
    if (this.componentRef) {
      // Enviar al componente dinámico datos
      this.componentRef.instance.value = this.config.value;
      // Escuchar @Output del componente dinámico
      if (this.componentRef.instance.dialogChange) {
        this.dialogChangeSubscription =
          this.componentRef.instance.dialogChange.subscribe(
            (value: DialogEvent) => {
              if (value) {
                this.valueChange = value;
                let dialogEvent: DialogEvent = value;
                if (dialogEvent.isButtonActionDisabled) {
                  this.buttonActionDisabled = true;
                } else {
                  this.buttonActionDisabled = false;
                }
                if (dialogEvent.value) {
                  this.valueChange = dialogEvent.value;
                }
              }
            }
          );
      }
      ///
      if (this.componentRef.instance.change) {
        this.changeSubscription = this.componentRef.instance.change.subscribe(
          (value: any) => {
            if (value) {
              this.valueChange = value;
              if (
                value == 'disabled' &&
                this.config.componentToLoad ==
                  ElectronicBillingSaveComprobantesComponent
              ) {
                // Disabled necesario para componente dialogo de facturacion electronica.
                this.buttonActionDisabled = !this.buttonActionDisabled;
              }

              // Disabled necesario para componente dialogo de eliminar usuario.
              if (
                value == 'disabled' &&
                (this.config.componentToLoad == ConfigDeleteUserComponent ||
                  this.config.componentToLoad ==
                    ConfigAddEditNotificationsComponent ||
                  this.config.componentToLoad ==
                    ConfigAddEditCompensationComponent ||
                  this.config.componentToLoad ==
                    ElectronicBillingDownloadLibroIvaComponent ||
                  this.config.componentToLoad ==
                    ConfigEditCashflowNameComponent ||
                  this.config.componentToLoad == DialogChangePasswordComponent)
              ) {
                this.buttonActionDisabled = true;
              } else {
                this.buttonActionDisabled = false;
              }

              //Caso especial porque es un formulario con 2 tipos de baja de agente
              if (
                value == 'close' &&
                this.config.componentToLoad == RrhhRemoveAgentComponent
              ) {
                this.closeButton();
              }

              //Caso especial para Rendiciones → finalizar Movimientos
              if (
                value.close == 'close' &&
                this.config.componentToLoad == RenditionFinishMovementsComponent
              ) {
                this.closeButton(value.action);
              }

              // Caso especial para Rendiciones → Borrador creado con éxito, 2 acciones
              if (
                value.close == 'close' &&
                this.config.componentToLoad == RenditionDraftCreatedComponent
              ) {
                this.closeButton(value.action);
              }
            }
          }
        );
      }
      ////
    }
  }

  getContentHeight(): string {
    let height: string;
    if (this.config.textButtonAction || this.config.textButtonCancel) {
      height = 'calc(' + this.config.height + ' - 72px - 72px)'; // con botbar
    } else {
      height = 'calc(' + this.config.height + ' - 72px)';
    }
    return height;
  }
}
